module.exports = __webpack_public_path__ + "static/media/applet.c734f7ee.png";